<template>
  <div class="slideshows">
    <slideshow :uid="slideshows[0].uid"></slideshow>
  </div>
</template>

<script>
import Slideshow from './Slideshow'

export default {
  name: 'slideshows',
  components: {
    'slideshow': Slideshow
  },
  computed: {
    slideshows () {
      return this.$store.getters.getPagesByType('Slideshow')
    },
  },
  data () {
    return {
      // slideshows: [],
    }
  },
  created () {
    // this.slideshows = this.subpages.slice()
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/base';

  .slideshows {
  }
</style>




// WEBPACK FOOTER //
// client/components/Slideshows.vue